import React, {Component} from 'react'
import {Link} from 'react-router-dom'

// Private Component
import Spinner from './Spinner'
import {confirmEmail} from "../../actions/authActions"

//Style
import "./confirm.css"
import Container from "@material-ui/core/Container"
import Grid from "@material-ui/core/Grid"

export default class Confirm extends Component {

    // A bit of state to give the user feedback while their email
    // address is being confirmed on the User model on the server.
    state = {
        confirming: true
    }

    componentDidMount = () => {
        const {cd, em} = this.props.match.params
        console.log(cd, em)
        if (!!cd && !!em) {
            confirmEmail(cd, em)
                .then(response => {
                    if (response.status === 200 && response.data === "ok") {
                        this.setState({ confirming: false })
                    }
                })
                .catch((e)=>console.log(e))
        }
    }

    render = () =>
        <Container maxWidth="sm">
            <Grid
                container
                spacing={0}
                direction="column"
                alignItems="center"
                justify="center"
                style={{minHeight: '95vh'}}
            >
                {this.state.confirming
                    ?
                    <p className="confirm-intro">Vérification de vos données...</p>
                    :
                    <sapn>
                        <p className="confirm-intro">Votre email est validé,
                            retournez sur votre application justNow</p>
                        <p>Ouvrir le menu (touchez 3 barres en haut à droite)</p>
                        <p>Touchez en bas "Connexion Pro"</p>
                    </sapn>

                }
                <div className='confirm'>
                    {this.state.confirming
                        ?
                        <Spinner size='8x' spinning={'spinning'}/>
                        : null
                    //     <Button
                    //     variant="contained"
                    //     color="primary"
                    //     type="submit"
                    //     component={Link}
                    //     onClick={()=>
                    //         //window.location.replace("intent://instagram.com/#Intent;scheme=https;package=com.instagram.android;end")
                    //         window.location.replace("intent://justnow.app/#Intent;scheme=https;package=com.jamaisvuca.justnow;end")
                    //     }
                    //     //to={'/login'}
                    //
                    //         >
                    //     Ouvrir l'application
                    // </Button>
                    }
                </div>
            </Grid>
        </Container>
}
